import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';

import routes from 'routing/routes';
import { ReactComponent as Logo } from 'assets/logo.svg';
import { AuthenticationActionsContext, AuthenticationDataContext } from 'containers/data_context';
import LoginForm from 'components/login_form/login_form';

import styles from './login_page.module.scss';
import notification from 'utils/notification';
import { ILoginData } from 'components/login_form/login_form.types';

const LoginPage: React.FC = () => {
  const { login, setLoggedInUser, resetPassword } = useContext(AuthenticationActionsContext);
  const { user } = useContext(AuthenticationDataContext);

  if (user) {
    const from = { pathname: routes.bookingsPage };

    return <Redirect to={from} />;
  }

  const handleLogin = async (loginData: ILoginData) => {
    try {
      const data = await login(loginData);
      if (data?.session) {
        setLoggedInUser(data.session);
        return null;
      } else {
        return data;
      }
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    } catch (e: any) {
      console.error(e.message, 'error');
      notification.withIcon('error', e.message);
      return null;
    }
  };

  const handlePasswordReset = async (email: string) => {
    await resetPassword(email);
  };

  return (
    <div data-testid="LoginPage" className={styles.root}>
      <div className={styles.login_container}>
        <div className={styles.logo_container}>
          <Logo />
        </div>
        <LoginForm onLogin={handleLogin} onPasswordReset={handlePasswordReset} />
      </div>
    </div>
  );
};

export default LoginPage;
